import Sliders from "../controllers/Sliders";

export default class TabbedWoocommerceSliders {
	constructor() {
		this.sliders = document.querySelectorAll(".theeblock--tabbed-woocommerce-sliders");
		if (this.sliders) {
			this.init();
		}
	}

	init() {
		this.sliders.forEach((slider) => {
			const tabs = slider.querySelectorAll(".tabs button");
			tabs.forEach((tab) => {
				tab.addEventListener("click", (e) => {
					this.fetchSlider(slider, tab);
				});
			});
		});
	}

	fetchSlider(slider, tab) {
		const container = slider.querySelector(".slider-container");
		const tabs = slider.querySelectorAll(".tabs button");
		const query = tab.dataset.query;
		const title = tab.dataset.title;

		container.innerHTML = '<p class="flex items-center justify-center"><i class="fa-duotone fa-spinner fa-spin-pulse"></i><span class="ml-1 text-sm">Loading...</span></p>';

		tabs.forEach((tab) => {
			tab.classList.remove("bg-orange");
			tab.classList.remove("text-white");
			tab.classList.add("bg-white");
			tab.classList.add("font-normal");
		});
		
		tab.classList.remove("bg-white");
		tab.classList.remove("font-normal");
		tab.classList.add("bg-orange");
		tab.classList.add("text-white");
		tab.classList.add("font-bold");

		if (query) {
			const data = new FormData();
			data.append("action", "tab_slider");
			data.append("query", query);
			data.append("title", title);

			fetch(EHTScripts.url.ajax, {
				body: data,
				credentials: "same-origin",
				headers: {
					Accept: "application/json",
				},
				method: "POST",
			})
				.then((resp) => {
					return resp.json();
				})
				.then((resp) => {
					container.innerHTML = resp;
				})
				.then(() => {
					new Sliders();
				})
				.catch((error) => console.log(error));
		}
	}
}
